import {
  Dialog, DialogContent, DialogTitle, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ModalActionBar from 'components/modal-action-bar/modal-action-bar';
import { ListingEntry } from 'graphql/listings/queries';
import { TFunction } from 'i18next';
import React, { FC, useState } from 'react';
import { NewTemplateType } from 'types/auto-templates';
import { listingItemtype } from 'types/ledger';

import { emptyTemplate } from '../utils/constants';
import { FormTemplate } from './form-template';

const FORM_ID = 'new-template-form';

type ModalNewTemplateProps = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  createTemplate: (payload: NewTemplateType) => Promise<boolean>;
  codeTemplates: string[];
  t: TFunction;
  partyRoles: ListingEntry[],
  transactionTypes: ListingEntry[],
  types: ListingEntry[],
  workflows: ListingEntry[];
  isSubmitting: boolean;
  listingsReady: boolean;
};

export const ModalNewTemplate: FC<ModalNewTemplateProps> = ({
  open,
  setOpen,
  createTemplate,
  codeTemplates,
  t,
  partyRoles,
  transactionTypes,
  types,
  workflows,
  isSubmitting,
  listingsReady,
}) => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const [isValid, setIsValid] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!isSubmitting && !isClosing) setOpen(false);
      }}
      TransitionProps={{ onExited: () => setIsClosing(false) }}
      fullScreen={isPhone}
      fullWidth={!isPhone}
      maxWidth="sm"
    >
      <DialogTitle>{t('documents:new-template')}</DialogTitle>
      <DialogContent>
        <FormTemplate
          formId={FORM_ID}
          hideSubmit
          onValidityChange={setIsValid}
          handleOnSubmit={createTemplate}
          template={emptyTemplate}
          codeTemplates={codeTemplates}
          closeModal={() => {
            setIsClosing(true);
            setOpen(false);
          }}
          partyRoles={partyRoles}
          transactionTypes={transactionTypes}
          types={types}
          workflows={workflows}
          isSubmitting={isSubmitting || isClosing}
          listingsReady={listingsReady}
        />
      </DialogContent>
      <ModalActionBar
        form={FORM_ID}
        submitType="submit"
        submitText={t('common:save')}
        onCancel={() => setOpen(false)}
        isSubmitting={isSubmitting}
        submitDisabled={!isValid || !listingsReady || isClosing}
      />
    </Dialog>
  );
};

export default ModalNewTemplate;
